import { DialogTitle } from "@headlessui/react";
import { CheckCircleIcon, RocketLaunchIcon } from "@heroicons/react/24/outline";

import Modal from "../../../layouts/Modal";

// What Pro does that Lite doesn't, kept to the lead tools these buttons point at
const PRO_FEATURES = [
  "Certificates of Destruction generated in a click",
  "Collection notes to print or email straight to the customer",
  "COD tracking from collection through to completion",
  "Customer payments and self-billed invoicing",
];

interface ProFeatureModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  /** What the clicked button does, e.g. "Generating COD certificates" */
  feature: string;
}

/**
 * Shown in place of a lead tool that only Wilma Pro has. Lite carries the buttons so the page
 * matches Pro, but the work behind them lives there.
 */
export default function ProFeatureModal({ open, setOpen, feature }: ProFeatureModalProps) {
  return (
    <Modal open={open} setOpen={setOpen} width="sm:max-w-lg">
      <div className="-mx-4 -mt-5 sm:-mx-6 sm:-mt-6 rounded-t-lg bg-gradient-to-br from-primary-600 to-primary-900 px-6 pt-8 pb-7 text-center">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-white/10 ring-1 ring-white/20">
          <RocketLaunchIcon className="h-6 w-6 text-white" aria-hidden="true" />
        </div>
        <span className="mt-4 inline-flex items-center rounded-full bg-white/10 px-3 py-0.5 text-xs font-semibold uppercase tracking-wider text-primary-100 ring-1 ring-white/20">
          Wilma Pro
        </span>
        <DialogTitle as="h3" className="mt-3 text-xl font-semibold text-white">
          Available in Wilma Pro
        </DialogTitle>
        <p className="mt-1 text-sm text-primary-100">
          {feature} isn't currently part of Wilma Lite.
        </p>
      </div>

      <div className="pt-6">
        <p className="text-sm text-gray-600">
          Wilma Pro gives you the full set of lead management tools, including:
        </p>

        <ul className="mt-4 space-y-3">
          {PRO_FEATURES.map((item) => (
            <li key={item} className="flex items-start gap-x-3 text-sm text-gray-700">
              <CheckCircleIcon className="h-5 w-5 flex-shrink-0 text-primary-600" aria-hidden="true" />
              {item}
            </li>
          ))}
        </ul>

        <div className="mt-6 rounded-md bg-gray-50 px-4 py-3 text-sm text-gray-600 ring-1 ring-gray-200">
          Already on Wilma Pro? Manage this lead there. To upgrade, or if you need a hand, contact our support team.
        </div>
      </div>

      <div className="mt-6 flex justify-end">
        <button
          type="button"
          onClick={() => setOpen(false)}
          className="inline-flex w-full justify-center rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 sm:w-auto"
        >
          Got it
        </button>
      </div>
    </Modal>
  );
}
